export enum TableValueType {
  Text,
  Number,
  Date,
}

export enum TextSearchTableEnum {
  none,
  contains,
  perfectMatch,
}

export enum NumberSearchTableEnum {
  none,
  contains,
  equalTo,
  greaterThan,
  lessThan,
}

export enum DateSearchTableEnum {
  none,
  range,
  equalTo,
  greaterThan,
  lessThan,
}

export const TextSearchTableOption = [
  {
    label: "Contains",
    value: TextSearchTableEnum.contains,
  },
  {
    label: "Perfect match",
    value: TextSearchTableEnum.perfectMatch,
  },
];

export const NumberSearchTableOption = [
  {
    label: "Equal to",
    value: NumberSearchTableEnum.equalTo,
  },
  {
    label: "Greater than",
    value: NumberSearchTableEnum.greaterThan,
  },
  {
    label: "Less than",
    value: NumberSearchTableEnum.lessThan,
  },
  {
    label: "Contains",
    value: NumberSearchTableEnum.contains,
  },
];

export const DateSearchTableOption = [
  {
    label: "Equal to",
    value: DateSearchTableEnum.equalTo,
  },
  {
    label: "Greater than",
    value: DateSearchTableEnum.greaterThan,
  },
  {
    label: "Less than",
    value: DateSearchTableEnum.lessThan,
  },
  {
    label: "Range",
    value: DateSearchTableEnum.range,
  },
];
